export default "__VITE_ASSET__CdGZxr93__"